export const THROTTLE_DELAY_MS = 1200;
export const enqueueRequest = fn => {
  return new Promise((resolve, reject) => {
    queue.push({
      fn,
      reject,
      resolve
    });
    if (!processing) {
      processing = true;
      processNext();
    }
  });
};
const queue = [];
let processing = false;
function processNext() {
  const task = queue.shift();
  if (!task) {
    processing = false;
    return;
  }
  task.fn().then(task.resolve).catch(task.reject);
  setTimeout(processNext, THROTTLE_DELAY_MS);
}
//# sourceMappingURL=request-queue.js.map